import { render, staticRenderFns } from "./proposition.vue?vue&type=template&id=751f3588"
import script from "./proposition.vue?vue&type=script&lang=ts"
export * from "./proposition.vue?vue&type=script&lang=ts"
import style0 from "./proposition.vue?vue&type=style&index=0&id=751f3588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports